export enum actionTypes {
  GENEROS_FETCH = 'GENEROS_FETCH',
  GENEROS_SUCCESS = 'GENEROS_SUCCESS',
  GENEROS_ERROR = 'GENEROS_ERROR',
  GENEROS_RESET = 'GENEROS_RESET',
}

export enum GenerosStatus {
  Idle,
  Loading,
  Error,
  Success,
}

export interface Genero {
  id: number
  nombre: string
}

export interface GenerosState {
  status: GenerosStatus
  generos: Array<Genero>
}

export interface GenerosFetch {
  type: typeof actionTypes.GENEROS_FETCH
  payload: null
}

export interface GenerosSuccess {
  type: typeof actionTypes.GENEROS_SUCCESS
  payload: { generos }
}

export interface GenerosError {
  type: typeof actionTypes.GENEROS_ERROR
  payload: null
}

export interface GenerosReset {
  type: typeof actionTypes.GENEROS_RESET
  payload: null
}

export type GenerosActions =
  | GenerosFetch
  | GenerosSuccess
  | GenerosError
  | GenerosReset

export const initialState: GenerosState = {
  status: GenerosStatus.Idle,
  generos: [],
}